import * as turf from '@turf/turf'
import { IPet, IPoint } from '../../interfaces/types.ts'
import { mapState, setZoom } from '../../store/mapState.ts'
import { dataState } from '../../store/dataState.ts'
import { historyState } from '../../store/historyState.ts'
import { controlState } from '../../store/controlState.ts'
import { drawerState } from '../../store/drawerState.ts'


export const getCenterOfSafeZone = (path: { lat: number, lng: number }[]) => {
    const coords = path.map(p => [p.lng, p.lat])
    // const last = coords.length - 1
    //
    // // TODO: sometimes the polygons aren't closed - fix that issue
    // if (coords[0][0] !== coords[last][0] && coords[0][1] !== coords[last][1]) {
    //     coords.push(coords[0])
    // }
    let polygon
    let turfCenter
    try {
        polygon = turf.polygon([coords], {})

        // @ts-ignore
        turfCenter = turf.center(polygon)
    } catch (e) {
        const last = coords.length - 1
        if (coords[0][0] !== coords[last][0] && coords[0][1] !== coords[last][1]) {
            coords.push(coords[0])
            polygon = turf.polygon([coords], {})
            // @ts-ignore
            turfCenter = turf.center(polygon)
        }
    }
    return { lng: turfCenter?.geometry.coordinates[0], lat: turfCenter?.geometry.coordinates[1] }
}

export const centerMap = (point: IPoint, map: google.maps.Map) => {
    if (point?.properties?.status) {
        const latLng = new google.maps.LatLng({
            lat: point?.properties?.latitude,
            lng: point?.properties?.longitude,
        })
        map.panTo(latLng)
    }
}

export const centerMapOnPet = (pet: IPet) => {
    const map = mapState.map!
    const device = dataState.devices?.find(d => d.petId === pet._id)
    if (device?.lastLocation && Object.keys(device.lastLocation).length) {
        const position = new window.google.maps.LatLng({
            lat: device.lastLocation?.properties?.latitude,
            lng: device.lastLocation?.properties?.longitude
        })
        map.panTo(position)
    }
}

export const centerMapOnPets = (history?: boolean, disabled?: boolean) => {
    if (disabled) return
    const map = !history ? mapState.map! : historyState.map!
    let bounds = !history ? mapState.bounds : historyState.bounds
    const historyLocations = historyState.locations?.filter(s => s?.properties?.status) || []

    const myPosition = mapState.myPosition
    let hasBounds = false
    if (!bounds) {
        bounds = new google.maps.LatLngBounds()
    }
    if (!history) {
        // Main map — include all pet locations and user position if available
        const devices = dataState.devices
        devices.forEach(d => {
            if (d.lastLocation?.properties?.latitude && d.lastLocation?.properties?.longitude) {
                bounds.extend(new google.maps.LatLng({
                    lat: d.lastLocation.properties.latitude,
                    lng: d.lastLocation.properties.longitude,
                }))
                hasBounds = true
            }
        })
        if (myPosition) {
            bounds.extend(myPosition)
            hasBounds = true
        }
    } else {
        historyLocations.forEach((point: IPoint) => {
            const latLng = new google.maps.LatLng({
                lat: point?.properties?.latitude,
                lng: point?.properties?.longitude,
            })
            bounds.extend(latLng)
            hasBounds = true
        })
    }
    if (hasBounds) {
        const isMobile = controlState.isOnMobileDevice
        const petListVisible = drawerState.petList
        const padding = !history && !isMobile && petListVisible ? { left: 380, top: 20, right: 20, bottom: 20 } : undefined
        map.fitBounds(bounds, padding)
        setTimeout(() => {
            const zoom = map.getZoom() || 0
            if (zoom > 16) {
                map.setZoom(16)
                setZoom(16)
            } else {
                setZoom(zoom)
            }
        })
    } else {
        setZoom(map.getZoom() || 16)
    }
}
